import loadable from '@loadable/component';

const ProductTabStatistics = loadable(() =>
  import(
    /* webpackChunkName: "ProductTabStatistics" */ './product-tab-statistics'
  )
);

export default ProductTabStatistics;
